// Format a "shared N times · last DD Mon" hint from a share-link API response.
export function shareHint({ share_count, last_shared_at } = {}) {
  const count = Number(share_count || 0);
  if (!count) return '';
  let when = '';
  if (last_shared_at) {
    try {
      when = new Date(last_shared_at).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
    } catch { /* ignore */ }
  }
  const times = `Shared ${count}\u00d7`;
  return when ? `${times} · last ${when}` : times;
}
